import { SectionConfig } from "../../types";
import { selectRuleLabels } from "../selectors";

const config: SectionConfig = {
  section: "ruleLabels",
  titleKey: "confirmRuleUpdates.ruleLabelChanges.title",
  selector: selectRuleLabels,
  properties: {
    name: { label: "ruleName" },
    description: { label: "ruleDescription" },
    locale: {
      label: "orgAndDomains:org.locale",
      format: { resolve: "locale" },
    },
    timeZone: { label: "orgAndDomains:org.timezone", format: "text" },
  },
};

export default config;
